import React from "react";
import { Cell, Row } from "../../../components/List";
import { Button } from "../../../components/Buttons";
import { Times } from "../../../components/Icon";

const sanitizeDescription = string => {
  return string.length > 30 ? string.slice(0, 29) + '...' : string;
}

const labelString = source => {
  const description = source?.description ?? 'Click for details...';

  return sanitizeDescription(description);
}

export function InvoiceRelationSourceListItem(props){
    const onDelete = () => {
      props.onDelete(props.source.id)
    }
    return (
      <Row key={props.source.id}>
        <Cell>{labelString(props.source)}</Cell>
        <Cell>
          <Button onClick={onDelete}>
            <Times />
          </Button>
        </Cell>
      </Row>
    );
}
